export default "__VITE_ASSET__R9a8fUBY__"